import React from 'react'
import cx from 'classnames'
import './styles.css'

const NotFound = () => (
  <section className={cx('section', 'page404-container')}>
    <p>Sorry! But it seems I don&#39;t have a page to serve this route just yet!</p>
  </section>
)

export default NotFound



// WEBPACK FOOTER //
// ./src/client/containers/notFound/index.js